/**
 * Derived polar outputs (`PolarOutputs`). Composes the canonical maths
 * in `polar.ts` into the four headline numbers and feeds both the stat cards
 * and the chart markers. Never stored — recomputed on every config change.
 */
import {
  bestLD,
  minSink,
  speedToFly,
  xcSpeed,
  type BestLD,
  type PolarCoeffs,
  type SpeedSink,
  type XCSpeeds,
} from "./polar";

export type PolarOutputs = {
  readonly minSink: SpeedSink;
  readonly bestLD: BestLD;
  readonly speedToFly: SpeedSink | null;
  readonly xcSpeed: XCSpeeds | null;
};

/**
 * Compute all derived outputs from *effective* coefficients (i.e. after ballast
 * and bugs have been applied via `effectiveCoeffs`). `xcSpeed` is `null` exactly
 * when `speedToFly` is — the MC tangent has no real solution.
 */
export const computeOutputs = (
  coeffs: PolarCoeffs,
  mc_ms: number,
  hw_kmh: number,
): PolarOutputs => {
  const stf = speedToFly(coeffs, mc_ms, hw_kmh);
  return {
    minSink: minSink(coeffs),
    bestLD: bestLD(coeffs),
    speedToFly: stf,
    xcSpeed: stf !== null ? xcSpeed(stf, mc_ms, hw_kmh) : null,
  };
};
